import { createSelector } from 'reselect';

import * as types from './../actions/actionTypes.js';
import { getPatternsPerPageLimit } from './ui.patterngallery';
import { getBreakpointMaxWidth } from './breakpoint';


export default (state, action, patternPerPage = 100) => {
    switch (action.type) {

        case types.LAZY_LOAD_INTERSECTION_TRIGGERED:
            const limit = patternPerPage - action.pagePerLoad;
            console.log({count: action.count, limit});
            return Object.assign({}, state, { show: action.count >= limit });

        default:
            return state;
    }
};

export const getContainerPaginationLimit = createSelector(
    [getBreakpointMaxWidth],
    width => {
        if (width <= 501) {
            return 1;
        }
        if (width <= 601) {
            return 2;
        }
        if (width <= 701) {
            return 3;
        }
        if (width <= 801) {
            return 5;
        }
        if (width <= 901) {
            return 7;
        }
        if (width <= 1023) {
            return 10;
        }
        return 13;
    },
);

export const getPaginationPageCount = (state, totalHits) => {
    const limit = getPatternsPerPageLimit(state);
    return Math.ceil(totalHits / limit);
};

export const getShowPagination = state => state.stolo.ui.pagination.show;

export const showPagination = (state, totalHits) => {
    const limit = getPatternsPerPageLimit(state);
    const show = getShowPagination(state);
    const pageCount = Math.ceil(totalHits / limit);
    if (pageCount > 1 && show) {
        return true;
    }
};

export const getPaginationType = state => state.location.type;



// WEBPACK FOOTER //
// ./src/reducers/ui.pagination.js